import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField, Autocomplete, Checkbox } from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import * as types from 'constants/actionTypes';

const BranchMultiSelectAutoCompleteInput = ({
  label,
  name,
  defaultValues, inputStyles, className, style, provinceFilter
}) => {
  const dispatch = useDispatch();
  // Getting state from Redux store
  const { userBranches, branchId } = useSelector((state) => state.common) || [];
  const [options, setOptions] = useState([]);
  const [values, setValues] = useState([]);
  const allSelected = options.length === values.length;

  const handleToggleOption = (selectedOps) => setValues(selectedOps);

  const handleClearOptions = () => {
    setValues([]);
    dispatch({ type: types.FORM_INPUT, value: [], name });
  }

  useEffect(() => {
    // Define Branch options
    if (userBranches && userBranches.length > 0) {
      let filterBranches = [...userBranches]
      if (provinceFilter != undefined && provinceFilter != "All") {
        filterBranches = userBranches.filter((item) => item.provinceState == provinceFilter)
      }

      const newOptions = filterBranches.map((item) => ({
        title: item.name,
        value: item.id.toString()
      }));

      setOptions(newOptions);
      if (defaultValues){
        const defaultValueArr = defaultValues && typeof defaultValues === "string" ? [defaultValues] : defaultValues.map(item => item.value);
        const defaultOption = defaultValues && defaultValues.length > 0 ?
        newOptions.filter(item => defaultValueArr.includes(item.value)) : [];
        // console.log(defaultValues, defaultOption);
        // Setup the default value on Redux
        setValues(defaultOption);
        dispatch({ type: types.FORM_INPUT, value: defaultValueArr, name });
      }
    }
  }, [userBranches, provinceFilter]);

  const handleChange = (event, selectedOps, reason) => {
    if (reason === "selectOption" || reason === "removeOption") {
      if (selectedOps.find((option) => option.title === "All")) {
        // console.log(allSelected);
        if (!allSelected) {
          setValues(options);
          const result = options.filter((el) => el.title !== "All");
          dispatch({ type: types.FORM_INPUT, value: result.map(item => item.value), name });
        } else {
          handleClearOptions();
        }

      } else {
        handleToggleOption && handleToggleOption(selectedOps);
        dispatch({ type: types.FORM_INPUT, value: selectedOps.map(item => item.value), name });
      }
    } else if (reason === "clear") {
      handleClearOptions && handleClearOptions();
    }
  };

  const filter = createFilterOptions();

  return (
    <div className={`form-group BranchSelectMultiple ${values.length > 5 ? `hideChips` : `showChips`} ${className}`}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={options}
        value={values}
        getOptionLabel={(option) => option.title}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          return [{ id: 0, title: 'All' }, ...filtered];
        }}
        sx={{ style }}
        renderOption={(props, option, { selected }) => {
          // To control the state of 'select-all' checkbox
          const selectAllProps =
            option.title === "All" ? { checked: allSelected } : {};
          return (
            <li key={option.value} {...props} className="select-list-item">
              <Checkbox checked={selected} {...selectAllProps} />
              {option.title}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField {...params} label={label} variant="outlined"
            sx={{
              "&.MuiInputBase-root": {
                ...inputStyles
              }
            }}
            placeholder={values.length > 5 ? `${values.length} selected` : ``} InputLabelProps={{ shrink: true }} />
        )}
        onChange={handleChange}
      />
    </div>
  );
}

BranchMultiSelectAutoCompleteInput.defaultProps = {
  options: [],
  values: []
};

export default BranchMultiSelectAutoCompleteInput;
